import { environment } from 'src/environment';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { FooterService } from '../../services/footer.service';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent implements OnInit {
  
  @Input() footerSlug:string;
  @Input() footerNavText:string;
  innerWidth;

  skinName = environment.skinName;
  constructor() { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;

  }

}
